import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Observable } from "rxjs";

@Injectable({
    providedIn: "root"
})
export class UrlHostnameGuardService {
    constructor(public router: Router) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
        const hostname = window.location.hostname.toLowerCase();

        // Permitir acceso si el hostname contiene alguno de los valores permitidos
        const allowedHostnames = ["uat.feedbalia", "exxita", "localhost", "new"];

        const isAllowed = allowedHostnames.some((allowed) => hostname.includes(allowed));

        if (!isAllowed) {
            // Redirigir a inicio si no está permitido
            this.router.navigate(["inicio"]);
            return false;
        }

        return true;
    }
}

@Injectable({
    providedIn: "root"
})
export class UrlHostnameSecondLifeGuardService {
    constructor(public router: Router) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
        const hostname = window.location.hostname.toLowerCase();

        // Permitir acceso si el hostname contiene alguno de los valores permitidos
        const allowedHostnames = ["uat-2life.feedbalia", "localhost", "qr-acceso.2life.market"];

        const isAllowed = allowedHostnames.some((allowed) => hostname.includes(allowed));

        if (!isAllowed) {
            // Redirigir a inicio si no está permitido
            this.router.navigate(["inicio"]);
            return false;
        }

        return true;
    }
}
